import { makeStyles } from 'tss-react/mui';
import ReactMarkdown from 'react-markdown';
import { ReactMarkdownOptions } from 'react-markdown/lib/react-markdown';
import { CSSProperties } from 'react';


const useStyles = makeStyles({ name: 'markdown-overrides' })(theme => ({
  root: {
    '& blockquote': {
      ...theme.typography.body1 as CSSProperties,
      margin: theme.spacing(1, 0),
      backgroundColor: theme.palette.grey[100],
      padding: theme.spacing(1, 2),
      borderRadius: theme.shape.borderRadius,
      border: `1px solid ${theme.palette.grey[200]}`,
      borderLeft: `4px solid ${theme.palette.grey[300]}`,

      '& p': {
        backgroundColor: theme.palette.grey[100],
        margin: 0
      }
    },
    '& ul, & ol': {
      ...theme.typography.body1 as CSSProperties,
      paddingLeft: theme.spacing(3),
      '& p': {
        margin: 0,
      }
    },
    '& h1': { ...theme.typography.h1 as CSSProperties, marginTop: 0, marginBottom: theme.spacing(2) },
    '& h2': { ...theme.typography.h2 as CSSProperties, marginTop: 0, marginBottom: theme.spacing(2) },
    '& h3': { ...theme.typography.h3 as CSSProperties, marginTop: 0, marginBottom: theme.spacing(2) },
    '& h4': { ...theme.typography.h4 as CSSProperties, marginTop: 0, marginBottom: theme.spacing(2) },
    '& h5': { ...theme.typography.h5 as CSSProperties, marginTop: 0, marginBottom: theme.spacing(2) },
    '& h6': { ...theme.typography.h6 as CSSProperties, marginTop: 0, marginBottom: theme.spacing(2) },
    '& p': {
      ...theme.typography.body1 as CSSProperties,
      '& code': {
        fontSize: 14,
        padding: '1px 2px',
        backgroundColor: theme.palette.grey[100],
        border: `1px solid ${theme.palette.grey[200]}`,
        borderRadius: theme.shape.borderRadius,
      },
    },
    '& hr': {
      border: 'none',
      borderTop: `1px solid ${theme.palette.divider}`,
    },
    '& pre': {
      fontSize: 14,
      border: `1px solid ${theme.palette.grey[200]}`,
      padding: theme.spacing(1, 1.5),
      backgroundColor: theme.palette.grey[100],
      borderRadius: theme.shape.borderRadius,
    },
    '& strong': {
      ...theme.typography.body1 as CSSProperties,
      fontWeight: 600,
    },
  }
}));

export type MarkdownProps = {
  children: string;
  skipHtml?: boolean;
  components?: ReactMarkdownOptions['components'];
};

export const Markdown: React.FC<MarkdownProps> = ({ skipHtml, children, components }) => {
  const { classes } = useStyles();

  return (
    <ReactMarkdown className={classes.root} components={components} skipHtml={skipHtml}>
      {children}
    </ReactMarkdown>
  );
};
